import { Button, Col, Result, Row, Spin, Typography } from "antd";
import { FunctionComponent, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useStateIfMounted } from "use-state-if-mounted";
import { ROUTE_DASHBOARD_TAGS } from "../../../shared/app-constants";
import getDashboardRoute from "../../../shared/get-dashboard-route";
import OrganizationModel from "../../../shared/organization-model";
import uDayjs from "../../../shared/uDayjs";
import httpClient from "../../http-client";

interface OrganizationDetailPageProps { }

const OrganizationDetailSuperAdminPage: FunctionComponent<
  OrganizationDetailPageProps
> = () => {
  const [loading, setLoading] = useStateIfMounted(true);
  const [data, setData] = useStateIfMounted<OrganizationModel | undefined>(
    undefined
  );
  const { id } = useParams();
  useEffect(() => {
    (async () => {
      setLoading(true);
      setData(undefined);
      try {
        const response = await httpClient.get(`organization/${id}`);
        if (response.data?.data) {
          setData(response.data.data);
        }
      } catch (e) { }
      setLoading(false);
    })();
  }, [id]);

  return (
    <div>
      <Row>
        <Col xs={24}>
          {!loading && !data && (
            <Result
              status={404}
              title="Not found!"
              subTitle="The organization you looking for can't be found!"
              extra={
                <Link
                  to={{ pathname: getDashboardRoute({}, ROUTE_DASHBOARD_TAGS) }}
                >
                  <Button type="link">Go Back</Button>
                </Link>
              }
            />
          )}
          {loading && <Spin />}
          {!loading && data && (
            <table className="gear-table">
              <tbody>
                <tr>
                  <th>Name</th>
                  <td>{data.name}</td>
                </tr>
                <tr>
                  <th>UPN</th>
                  <td>{data.upn}</td>
                </tr>
                <tr>
                  <th>Owner</th>
                  <td>{data.owner?.name}</td>
                </tr>

                <tr>
                  <th>Created By</th>
                  <td>
                    <div>
                      <Typography.Text>
                        {(data as any)?.created_by?.name}
                      </Typography.Text>{" "}
                    </div>
                    <Typography.Text type="secondary">
                      {uDayjs(data.created_at).format(`DD/MM/YYYY hh:mma`)}
                    </Typography.Text>
                  </td>
                </tr>
                <tr>
                  <th>Updated By</th>
                  <td>
                    <div>
                      <Typography.Text>
                        {(data as any)?.updated_by?.name}
                      </Typography.Text>{" "}
                    </div>
                    <Typography.Text type="secondary">
                      {uDayjs(data.updated_at).format(`DD/MM/YYYY hh:mma`)}
                    </Typography.Text>
                  </td>
                </tr>
                <tr>
                  <th>Gears</th>
                  <td>{data._count?.gears ?? 0}</td>
                </tr>
                <tr>
                  <th>Tags</th>
                  <td>{data._count?.tags ?? 0}</td>
                </tr>
                <tr>
                  <th>Users</th>
                  <td>{data._count?.users ?? 0}</td>
                </tr>
                <tr>
                  <th>Roles</th>
                  <td>{data._count?.roles ?? 0}</td>
                </tr>
              </tbody>
            </table>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default OrganizationDetailSuperAdminPage;
